/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A contact linked to an organization, enriched with the per-link role.
 * @export
 * @interface OrganizationLinkedContact
 */
export interface OrganizationLinkedContact {
    /**
     * 
     * @type {number}
     * @memberof OrganizationLinkedContact
     */
    readonly id: number;
    /**
     * PA firm that owns this record
     * @type {number}
     * @memberof OrganizationLinkedContact
     */
    companyId: number;
    /**
     * Free-form contact type (e.g. insurance_adjuster, contractor_personnel, homeowner)
     * @type {string}
     * @memberof OrganizationLinkedContact
     */
    contactType: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedContact
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedContact
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedContact
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedContact
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedContact
     */
    jobTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedContact
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationLinkedContact
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationLinkedContact
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationLinkedContact
     */
    readonly updatedAt: Date;
    /**
     * Role of this contact within the organization (from the contact-organization link).
     * @type {string}
     * @memberof OrganizationLinkedContact
     */
    role?: string | null;
    /**
     * Whether this contact is the primary contact for the organization.
     * @type {boolean}
     * @memberof OrganizationLinkedContact
     */
    isPrimary?: boolean;
}

/**
 * Check if a given object implements the OrganizationLinkedContact interface.
 */
export function instanceOfOrganizationLinkedContact(value: object): value is OrganizationLinkedContact {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('contactType' in value) || value['contactType'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OrganizationLinkedContactFromJSON(json: any): OrganizationLinkedContact {
    return OrganizationLinkedContactFromJSONTyped(json, false);
}

export function OrganizationLinkedContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationLinkedContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'contactType': json['contactType'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'role': json['role'] == null ? undefined : json['role'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
    };
}

export function OrganizationLinkedContactToJSON(json: any): OrganizationLinkedContact {
    return OrganizationLinkedContactToJSONTyped(json, false);
}

export function OrganizationLinkedContactToJSONTyped(value?: Omit<OrganizationLinkedContact, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'contactType': value['contactType'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phone': value['phone'],
        'jobTitle': value['jobTitle'],
        'notes': value['notes'],
        'createdBy': value['createdBy'],
        'role': value['role'],
        'isPrimary': value['isPrimary'],
    };
}

